export default function listItemBlock(index) {
  return {
    list_item_index: index + 1
  };
}
